export default __webpack_public_path__ + "static/media/word-press.f310ad08.png";